import { useTranslation } from "react-i18next";
import SubTitle from "components/SubTitle";
import { useGetNotificationsQuery } from "features/api/reports/reportsSlice";
import { NotificationsType } from "models/NotificationsType";
import React from "react";

const Notifications = () => {
  const { t } = useTranslation();
  const { data: notifications } =
    useGetNotificationsQuery<NotificationsType[]>();

  const today = new Date().toLocaleDateString();
  const newNotifications: NotificationsType[] = notifications?.filter(
    (dt: NotificationsType) => !dt.isSeen
  );
  newNotifications?.sort(
    (a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
  );

  const prevNotifications: NotificationsType[] = notifications?.filter(
    (dt: NotificationsType) => dt.isSeen
  );
  prevNotifications?.sort(
    (a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
  );

  const getTimeTitle = (notif: NotificationsType) => {
    const isTodayNotification =
      new Date(notif.createdOn).toLocaleDateString() === today;
    return isTodayNotification
      ? new Date(notif.createdOn).toLocaleTimeString("he-IL", {
          hour: "numeric",
          minute: "numeric",
        })
      : new Date(notif.createdOn)
          .toLocaleDateString("he-IL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          .split(".")
          .join("/");
  };

  const renderNotifications = (notificationsArr: NotificationsType[]) => {
    return notificationsArr.map((dt, index) => (
      <div
        className="scudTextBoxNotification"
        key={`${dt.createdOn}-${index + 1}`}
      >
        <div className="title">{getTimeTitle(dt)}</div>
        {dt.headLine && <span className="bold">{dt.headLine}</span>}
        <div>{dt.content}</div>
        <a href={dt.url} target="_blank" rel="noopener noreferrer">
          {dt.url}
        </a>
      </div>
    ));
  };

  return (
    <div className="notiBox">
      <div className="titleBox">
        <div className="title">{t("labelUpdates")}</div>
      </div>
      <div className="scudContainer">
        <div className="whiteContainer">
          {newNotifications?.length === 0 && prevNotifications?.length === 0 ? (
            <span>{t("noUpdates")}</span>
          ) : (
            <>
              {newNotifications?.length > 0 && (
                <>
                  <SubTitle underLine className="bold">
                    {t("newUpdates")}
                  </SubTitle>
                  {renderNotifications(newNotifications)}
                </>
              )}

              {prevNotifications?.length > 0 && (
                <>
                  <SubTitle underLine>{t("previousUpdates")}</SubTitle>
                  {renderNotifications(prevNotifications)}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
